import {app} from "@/modules/app";
import {useStackRouteComponent} from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
    {
        parent: "public",
        path: "/fortune/dialog",
        component: useStackRouteComponent(
            () =>  import("@/pages/fortune/fortune.dialog.vue")
        ),
    },
    {
        parent: "public",
        path: "/fortune/terms",
        component: useStackRouteComponent(
            () =>   import("@/pages/fortune/terms.dialog.vue")
        ),
    },
]);

